'use client';

import type { FC } from 'react';
import { BlurImage } from '../ui/BlurImage';

export interface RainCaseBackdropProps {
  imageUrl: string;
  imagePlaceholder?: string | null;
  live?: boolean;
}

export const RainCaseBackdrop: FC<RainCaseBackdropProps> = ({ imageUrl, imagePlaceholder, live = false }) => (
  <>
    <div
      className={`pointer-events-none absolute inset-0 scale-[1.5] blur-[20px] ${live ? 'opacity-40' : 'opacity-25'}`}
    >
      <BlurImage src={imageUrl} placeholder={imagePlaceholder} alt="" className="h-full w-full" />
    </div>
    <div
      className="pointer-events-none absolute inset-0"
      style={{
        background: `radial-gradient(ellipse 120% 120% at 25% 50%, transparent 30%, rgba(5,5,15,${live ? 0.4 : 0.5}) 100%)`,
      }}
    />
  </>
);
